module.exports = __webpack_public_path__ + "static/media/klinecompany-logo.de943d1a.svg";